var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.707 19.121l-13-13a1 1 0 111.414-1.414l13 13a1 1 0 01-1.414 1.414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.121 4.707a1 1 0 00-1.414 0l-13 13a1 1 0 101.414 1.414l13-13a1 1 0 000-1.414"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCI+PHBhdGggZD0ibTE3LjcwNyAxOS4xMjEtMTMtMTNhMSAxIDAgMSAxIDEuNDE0LTEuNDE0bDEzIDEzYTEgMSAwIDAgMS0xLjQxNCAxLjQxNCIvPjxwYXRoIGQ9Ik0xOS4xMjEgNC43MDdhMSAxIDAgMCAwLTEuNDE0IDBsLTEzIDEzYTEgMSAwIDEgMCAxLjQxNCAxLjQxNGwxMy0xM2ExIDEgMCAwIDAgMC0xLjQxNCIvPjwvZz48L3N2Zz4=";
export { SvgClose as ReactComponent };